import { ActionTree, Action } from 'vuex';
import { RootState } from '@/store/types/root.state';
import { HomeState } from '@/store/types/home.state';
import Entry from "@/models/entry";
import db from "@/firebase";

export const actions: ActionTree<HomeState, RootState> = {
    async fetchEntries({ commit, state }) {
        const entries: Entry[] = [];
        console.log("HIII");
        db.collection('landing-entries').onSnapshot((data) => {
            commit('setLoading', true);
            console.log("data", data);
            data.docs.map((item, i) => {
                entries[i] = new Entry();
                entries[i].name = item.data().name;
                entries[i].url = item.data().url;
                entries[i].imageURL = item.data().imageURL;
                entries[i].position = item.data().position;
                entries[i].type = item.data().type;
                entries[i].types = item.data().types;
                entries[i].musicSub = item.data().musicSub;
                entries[i].workInProgress = item.data().workInProgress;
            })
            console.log(entries);
            entries.sort((a, b) => a.position - b.position);
            console.log(entries);
            commit('setArtEntries', entries.filter((e) => e.types.includes('Art')));
            commit('setWebEntries', entries.filter((e) => e.types.includes('Web Development')));
            commit('setAudiovisualEntries', entries.filter((e) => e.types.includes('Audiovisual Production')));
            commit('setSoftwareEntries', entries.filter((e) => e.types.includes('Software Development')));
            commit('setMusicEntries', entries.filter((e) => e.types.includes('Music')));
            commit('setGraphicDesignEntries', entries.filter((e) => e.types.includes('Graphic Design')));
            commit('setEntries', entries);
        });
    },
    async fetchData({ commit, dispatch }) {
        dispatch('fetchEntries');
    },
}